import React from "react";
import Logo from "./../assets/svg/logo.svg";
import { mediaLinks } from "../helper/Helper";
import footerSide from "./../assets/png/footer-side.png";
function Footer() {
  return (
    <>
      <div className="footer-bg relative">
        <div
          className="absolute left-0 bottom-0 max-w-[250px] xl:max-w-[300px]  min-[1450px]:max-w-[500px] min-[1800px]:max-w-[867px] z-30 hidden md:block"
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          <img src={footerSide} alt="img" className="w-full" />
        </div>
        <div
          id="footer"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8   py-16 sm:pt-36 2xl:pt-52 text-center relative"
        >
          <div className="min-[1780px]:max-w-[50%] min-[1510px]:max-w-[40%] max-w-[500px] xl:max-w-[845px] mx-auto text-center pt-20 xl:pt-40">
            <div
              className="flex justify-center"
              data-aos="zoom-in"
              data-aos-duration="2000"
            >
              <a href="#">
                <img
                  src={Logo}
                  alt="logo"
                  className="max-w-[100px] sm:max-w-[142px] lg:max-w-[181px] "
                />
              </a>
            </div>
            <p
              className="text-black text-base sm:text-lg lg:text-2xl 2xl:text-[24px] leading-[180%] my-4 lg:my-5"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              Josh is the strongest man on Solana right now. A video game and
              animation are currently being created behind the scenes. Be sure
              to join us before everything takes off.
            </p>
            <div className="flex justify-center gap-3 md:gap-5 sm:mb-10">
              {mediaLinks.map((item, index) => (
                <a
                  key={index}
                  href={item.link}
                  className="sm:w-12 sm:h-12 w-10 h-10 bg-white rounded-xl p-1 sm:p-3 flex flex-col justify-center items-center shadow-[1px_3px_0px_0px_#000] transition-all duration-300 ease-in-out group   hover:shadow-[0px_3px_10px_0px_#000]"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
